import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Replace with your actual Firebase config object
const firebaseConfig = {
  apiKey: "AIzaSyBcBmduyoTtR-OSwRyTzdDPqMLTBDX1yyY",
  authDomain: "student-tracking-platform.firebaseapp.com",
  projectId: "student-tracking-platform",
  storageBucket: "student-tracking-platform.firebasestorage.app",
  messagingSenderId: "579720000924",
  appId: "1:579720000924:web:31199cb0a254367cccc459"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;